/**
 * Builds a new instance of the MetricAnalysisBlock module.
 * @module MetricAnalysisBlock
 * @constructor
 */

/** @lends module:LegalsTextBlock */
function MetricAnalysisBlock (scope, util, element, params) {
    var that = this;
    var resizeTimer;
    that.attribute = 'data-stry-metrics-analysis-block';

    /*  Catch instantiation errors  */
    if (!scope && !util && !element && !params) { return; }  //  Registration condition
    else {
        if (!scope) { console.error('StoryStream -> MetricAnalysisBlock -> No scope provided.'); return; }
        if (!util) { console.error('StoryStream -> MetricAnalysisBlock -> No util available.'); return; }
        if (!element) { console.error('StoryStream -> MetricAnalysisBlock -> No element available.'); return; }
        if (!params) { console.error('StoryStream -> MetricAnalysisBlock -> No params provided.'); return; }

    }
    /*  End  */

    that.elem = element;
    that.elem_divide = null;
    that.elem_ellipsis = null;
    that.elem_line = null;
    that.elem_metrics = null;


    /**
     * Funnel all events through this method and distribute.
     * @memberof MetricAnalysisBlock
     * @function handleEvent
     * @param {object} e - Event data.
     * @inner
     */
    var handleEvent = function (e, params) {
        var type = e.type ? e.type : e.name;
        switch(type) {
            case 'viewport.change':


                if (e.detail.viewport.width < 768) {

                    willResetElements();
                }

                else {

                    //
                    willPositionElements();
                }

                break;
        }
    };

    var willResetElements = function () {

        that.elem_line.removeAttribute("style");
        that.elem_line.parentNode.removeAttribute("style");
        that.elem_metrics[0].removeAttribute("style");
        that.elem_metrics[2].removeAttribute("style");
    };

    var willPositionElements = function () {
        var angle = 6.38;  //  Set a default value.
        var metric_elem;
        var metric_rect;
        var offset_line;
        var sin;
        var x_length;
        var y_length;

        //  Calculate angle based on existing page 'divide' angles.
        if (that.elem_divide) {
            sin = that.elem_divide.offsetHeight / that.elem_divide.offsetWidth;
            radians = Math.asin(sin);
            angle = radians * (180 / Math.PI);
        }

        //  Add rotation angle to metric line and offset metric content accordingly.
        //  ** Currently, for this version we assume 3 metrics defined.
        if (that.elem_line) {

            //
            metric_elem = that.elem_metrics[that.elem_metrics.length - 1];
            metric_rect = metric_elem.getBoundingClientRect();

            //
            x_length = metric_rect.right - (metric_rect.width / 2);

            //
            x_length = x_length - that.elem.offsetWidth / 2;

            //  Calculate vertical height and apply offset based on ellipsis height.
            y_length = (x_length * Math.tan(radians));

            //
            that.elem_line.style.transform = "rotate(-" + angle + "deg)";

            //
            offset_line = (metric_elem.querySelector('figure').offsetHeight + (metric_elem.querySelector('.metric-ellipsis').offsetHeight / 2)) - (that.elem_line.offsetHeight / 2);

            //
            that.elem_line.parentNode.style.transform = "translate(-50%, " + offset_line / 10 + "rem)";

            //
            that.elem_metrics[0].style.transform = "translateY(" + y_length / 10 + "rem)";
            that.elem_metrics[2].style.transform = "translateY(-" + y_length / 10 + "rem)";
        }
    };


    /**
     * Function used to initialise the application.
     * @memberof MetricAnalysisBlock
     * @function init
     * @inner
     */
    var init = function () {

        //
        that.elem_divide = document.body.getElementsByClassName('module-block-divide')[0];
        that.elem_ellipsis = that.elem.querySelector('.metric-content .metric-ellipsis');
        that.elem_line = that.elem.querySelector('.metrics-line hr');
        that.elem_metrics = that.elem.getElementsByClassName('metric-content');

        //  Listen for all click events
        scope.addEventListener("viewport.change", handleEvent, false);
    };


    init();
    return that;
}
if (typeof module !== 'undefined' && exports !== null) {
    exports.MetricAnalysisBlock = MetricAnalysisBlock;
}
